var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 562.33 282.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#002d55;}.cls-3{fill:#b4c3d6;}.cls-4{fill:#b4c3d7;}.cls-5{fill:#ec8365;}.cls-6{fill:#698daf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Errorscreen"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m556.73,73c-14.77-3.16-30.57,1.5-46.04-.86-20.5-3.13-41.42-9.67-58.89-20.99-28.45-18.44-55.09-44.21-90.16-49.83-55.9-8.96-98.73,30.43-149.73,40.64-51.35,10.28-103.63-38-149.13,3.14-46.42,41.97-21.52,127.18,10.21,170.95,23.64,32.6,48.39,48.92,87.86,49.71,47.93.96,92.66-4.93,138.66-19.19,69.89-21.67,143.67-49.65,205.93-88.71,16.74-10.5,75.03-53.17,51.3-84.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m402.75,171.65c-.16,0-.31-.11-.35-.27l-10.46-40.64c-6.88-26.76-30.98-45.44-58.61-45.44-.2,0-.36-.16-.36-.36s.16-.36.36-.36c27.96,0,52.35,18.91,59.31,45.98l10.46,40.64c.05.2-.07.39-.26.44-.03,0-.06.01-.09.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m430.26,148.39v-21.16c0-4.62-3.76-8.38-8.38-8.38h-46.77c-.2,0-.36.16-.36.36v135.64c0,.2.16.36.36.36h46.77c.2,0,.36-.16.36-.36v-7.66c4.45-.19,8.02-3.87,8.02-8.37v-21.16c0-4.5-3.56-8.18-8.02-8.37v-7.31c4.45-.19,8.02-3.87,8.02-8.37v-21.16c0-4.5-3.56-8.18-8.02-8.37v-7.31c4.45-.19,8.02-3.87,8.02-8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m379.12,201.62h42.76c4.43,0,8.02-3.59,8.02-8.02v-21.16c0-4.43-3.59-8.02-8.02-8.02h-42.76v37.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m421.87,201.98h-42.76c-.2,0-.36-.16-.36-.36v-37.19c0-.2.16-.36.36-.36h42.76c4.62,0,8.38,3.76,8.38,8.38v21.16c0,4.62-3.76,8.38-8.38,8.38Zm-42.39-.72h42.39c4.22,0,7.66-3.43,7.66-7.66v-21.16c0-4.22-3.43-7.66-7.66-7.66h-42.39v36.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m379.12,156.41h42.76c4.43,0,8.02-3.59,8.02-8.02v-21.16c0-4.43-3.59-8.02-8.02-8.02h-42.76v37.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m421.87,156.77h-42.76c-.2,0-.36-.16-.36-.36v-37.19c0-.2.16-.36.36-.36h42.76c4.62,0,8.38,3.76,8.38,8.38v21.16c0,4.62-3.76,8.38-8.38,8.38Zm-42.39-.72h42.39c4.22,0,7.66-3.44,7.66-7.66v-21.16c0-4.22-3.43-7.66-7.66-7.66h-42.39v36.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m379.12,246.83h42.76c4.43,0,8.02-3.59,8.02-8.02v-21.16c0-4.43-3.59-8.02-8.02-8.02h-42.76v37.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m421.87,247.19h-42.76c-.2,0-.36-.16-.36-.36v-37.19c0-.2.16-.36.36-.36h42.76c4.62,0,8.38,3.76,8.38,8.38v21.16c0,4.62-3.76,8.38-8.38,8.38Zm-42.39-.72h42.39c4.22,0,7.66-3.43,7.66-7.66v-21.16c0-4.22-3.43-7.66-7.66-7.66h-42.39v36.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 294.93,
    y: 119.21,
    width: 92.21,
    height: 37.19,
    rx: 8.02,
    ry: 8.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m379.12,156.77h-76.17c-4.62,0-8.38-3.76-8.38-8.38v-21.16c0-4.62,3.76-8.38,8.38-8.38h76.17c4.62,0,8.38,3.76,8.38,8.38v21.16c0,4.62-3.76,8.38-8.38,8.38Zm-76.17-37.19c-4.22,0-7.66,3.43-7.66,7.66v21.16c0,4.22,3.43,7.66,7.66,7.66h76.17c4.22,0,7.65-3.44,7.65-7.66v-21.16c0-4.22-3.43-7.66-7.65-7.66h-76.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 294.93,
    y: 164.43,
    width: 92.21,
    height: 37.19,
    rx: 8.02,
    ry: 8.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m379.12,201.98h-76.17c-4.62,0-8.38-3.76-8.38-8.38v-21.16c0-4.62,3.76-8.38,8.38-8.38h76.17c4.62,0,8.38,3.76,8.38,8.38v21.16c0,4.62-3.76,8.38-8.38,8.38Zm-76.17-37.19c-4.22,0-7.66,3.43-7.66,7.66v21.16c0,4.22,3.43,7.66,7.66,7.66h76.17c4.22,0,7.65-3.43,7.65-7.66v-21.16c0-4.22-3.43-7.66-7.65-7.66h-76.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 294.93,
    y: 209.64,
    width: 92.21,
    height: 37.19,
    rx: 8.02,
    ry: 8.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m379.12,247.19h-76.17c-4.62,0-8.38-3.76-8.38-8.38v-21.16c0-4.62,3.76-8.38,8.38-8.38h76.17c4.62,0,8.38,3.76,8.38,8.38v21.16c0,4.62-3.76,8.38-8.38,8.38Zm-76.17-37.19c-4.22,0-7.66,3.43-7.66,7.66v21.16c0,4.22,3.43,7.66,7.66,7.66h76.17c4.22,0,7.65-3.43,7.65-7.66v-21.16c0-4.22-3.43-7.66-7.65-7.66h-76.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 145.27,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 369.09,
    cy: 141.26,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 137.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 145.27,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 137.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 369.09,
    cy: 133.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 129.24,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 129.24,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 361.08,
    cy: 141.26,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 145.27,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 137.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 361.08,
    cy: 133.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 129.24,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 353.06,
    cy: 141.26,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 145.27,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 137.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 353.06,
    cy: 133.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 129.24,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 345.04,
    cy: 141.26,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 145.27,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 137.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 345.04,
    cy: 133.25,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 129.24,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 190.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 369.09,
    cy: 186.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 182.47,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 190.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 182.47,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 369.09,
    cy: 178.46,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 174.45,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 174.45,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 361.08,
    cy: 186.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 190.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 182.47,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 361.08,
    cy: 178.46,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 174.45,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 353.06,
    cy: 186.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 190.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 182.47,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 353.06,
    cy: 178.46,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 174.45,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 345.04,
    cy: 186.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 190.48,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 182.47,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 345.04,
    cy: 178.46,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 174.45,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 235.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 369.09,
    cy: 231.69,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 227.68,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 235.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 227.68,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 369.09,
    cy: 223.67,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 373.1,
    cy: 219.66,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 365.09,
    cy: 219.66,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 361.08,
    cy: 231.69,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 235.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 227.68,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 361.08,
    cy: 223.67,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 357.07,
    cy: 219.66,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 353.06,
    cy: 231.69,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 235.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 227.68,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 353.06,
    cy: 223.67,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 349.05,
    cy: 219.66,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 345.04,
    cy: 231.69,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 235.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 227.68,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 345.04,
    cy: 223.67,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 341.03,
    cy: 219.66,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 307.36,
    y: 219.66,
    width: 3.21,
    height: 16.04,
    rx: 1.6,
    ry: 1.6,
    transform: "translate(617.92 455.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 315.37,
    y: 219.66,
    width: 3.21,
    height: 16.04,
    rx: 1.6,
    ry: 1.6,
    transform: "translate(633.95 455.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 307.36,
    y: 174.45,
    width: 3.21,
    height: 16.04,
    rx: 1.6,
    ry: 1.6,
    transform: "translate(617.92 364.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 315.37,
    y: 174.45,
    width: 3.21,
    height: 16.04,
    rx: 1.6,
    ry: 1.6,
    transform: "translate(633.95 364.93) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 307.36,
    y: 129.24,
    width: 3.21,
    height: 16.04,
    rx: 1.6,
    ry: 1.6,
    transform: "translate(617.92 274.51) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 315.37,
    y: 129.24,
    width: 3.21,
    height: 16.04,
    rx: 1.6,
    ry: 1.6,
    transform: "translate(633.95 274.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 304.61,
    y: 246.83,
    width: 77.82,
    height: 8.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m382.44,255.21h-77.82c-.2,0-.36-.16-.36-.36v-8.02c0-.2.16-.36.36-.36h77.82c.2,0,.36.16.36.36v8.02c0,.2-.16.36-.36.36Zm-77.46-.72h77.1v-7.29h-77.1v7.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 304.61,
    y: 201.62,
    width: 77.82,
    height: 8.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m382.44,210h-77.82c-.2,0-.36-.16-.36-.36v-8.02c0-.2.16-.36.36-.36h77.82c.2,0,.36.16.36.36v8.02c0,.2-.16.36-.36.36Zm-77.46-.72h77.1v-7.29h-77.1v7.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 304.61,
    y: 156.41,
    width: 77.82,
    height: 8.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m382.44,164.79h-77.82c-.2,0-.36-.16-.36-.36v-8.02c0-.2.16-.36.36-.36h77.82c.2,0,.36.16.36.36v8.02c0,.2-.16.36-.36.36Zm-77.46-.72h77.1v-7.29h-77.1v7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m129.51,254.85h18.9c18.43-25.51,27.69-59.01,27.69-92.46s-9.21-67.04-27.69-92.65c-6.19,6.19-11.34,12.99-15.45,20.22h0c-7.94-1.42-17.91-1.42-25.84,0h0c-4.11-7.23-9.26-14.03-15.4-20.22-18.47,25.61-27.69,59.1-27.69,92.65s9.26,66.95,27.69,92.46h37.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m148.41,255.21h-56.69c-.12,0-.22-.06-.29-.15-17.9-24.78-27.75-57.69-27.75-92.67s9.86-68.05,27.75-92.86c.06-.09.16-.14.27-.15.09-.03.21.03.29.11,6.03,6.07,11.19,12.83,15.33,20.07,7.88-1.37,17.58-1.37,25.47,0,4.17-7.28,9.34-14.04,15.38-20.08.07-.07.19-.12.29-.1.1,0,.2.06.26.15,17.9,24.81,27.75,57.79,27.75,92.86s-9.86,67.89-27.75,92.67c-.07.09-.18.15-.29.15Zm-56.51-.72h56.32c17.74-24.64,27.51-57.34,27.51-92.1s-9.72-67.44-27.37-92.09c-5.93,5.98-11,12.65-15.09,19.84-.08.13-.23.21-.38.18-7.93-1.42-17.79-1.42-25.72,0-.15.03-.3-.04-.38-.18-4.07-7.16-9.13-13.83-15.04-19.84-17.65,24.65-27.37,57.33-27.37,92.09s9.77,67.45,27.51,92.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 136.04,
    cy: 121.89,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 104.04,
    cy: 121.89,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m136.04,130.76c-4.89,0-8.87-3.98-8.87-8.87s3.98-8.87,8.87-8.87,8.87,3.98,8.87,8.87-3.98,8.87-8.87,8.87Zm0-17.01c-4.49,0-8.14,3.65-8.14,8.14s3.65,8.14,8.14,8.14,8.14-3.65,8.14-8.14-3.65-8.14-8.14-8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m104.04,130.76c-4.89,0-8.87-3.98-8.87-8.87s3.98-8.87,8.87-8.87,8.87,3.98,8.87,8.87-3.98,8.87-8.87,8.87Zm0-17.01c-4.49,0-8.14,3.65-8.14,8.14s3.65,8.14,8.14,8.14,8.14-3.65,8.14-8.14-3.65-8.14-8.14-8.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 138.77,
    cy: 125.12,
    r: 2.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 106.76,
    cy: 125.12,
    r: 2.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m88.48,94.19l8.46-1.25c.72-.11,1.09-.92.7-1.53l-4.23-6.63c-.41-.65-1.37-.61-1.73.07l-4.23,7.87c-.39.73.21,1.59,1.03,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.15,92.94l8.46,1.25c.82.12,1.42-.74,1.03-1.47l-4.23-7.87c-.36-.68-1.32-.71-1.73-.07l-4.23,6.63c-.39.61-.02,1.43.7,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m36.39,214.36c0,15.07,5.81,29.06,15.5,40.49h39.83c-18.43-25.51-27.69-59.01-27.69-92.46-16.96,12.76-27.64,31.32-27.64,51.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.71,255.21h-39.83c-.11,0-.21-.05-.28-.13-10.19-12.03-15.58-26.11-15.58-40.72,0-19.93,10.13-38.98,27.78-52.26.11-.08.26-.1.38-.04.12.06.2.19.2.33,0,34.83,9.81,67.59,27.62,92.25.08.11.09.25.03.38s-.19.2-.32.2Zm-39.66-.72h38.95c-17.51-24.54-27.2-56.93-27.34-91.37-17.11,13.12-26.92,31.75-26.92,51.24,0,14.38,5.29,28.26,15.3,40.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m132.41,255.21h-24.69c-.2,0-.36-.16-.36-.36v-44.85c0-2.63,1.01-5.08,2.85-6.92.45-.45.96-.86,1.58-1.27.16-.1.39-.07.5.1.11.17.06.39-.1.5-.57.38-1.05.76-1.47,1.18-1.7,1.7-2.63,3.97-2.63,6.41v44.49h23.97v-44.49c0-3.04-1.53-5.87-4.1-7.57-.17-.11-.21-.34-.1-.5s.34-.21.5-.1c2.77,1.84,4.42,4.9,4.42,8.18v44.85c0,.2-.16.36-.36.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m120.04,154.04c-3.58,0-7.16-.95-10.35-2.87-.17-.1-.23-.33-.12-.5.1-.17.32-.23.5-.12,6.15,3.69,13.8,3.69,19.95,0,.17-.1.39-.05.5.12.1.17.05.39-.12.5-3.19,1.91-6.77,2.87-10.35,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m19.95,254.85h48.88c13.04,0,23.65-10.61,23.65-23.65s-10.61-23.65-23.65-23.65c-4.41,0-7.99,3.58-7.99,7.99s3.58,7.99,7.99,7.99,7.68,3.45,7.68,7.68-3.44,7.68-7.68,7.68H19.95c-4.41,0-7.99,3.58-7.99,7.99s3.58,7.99,7.99,7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.85,215.53c0,4.41,3.56,7.97,7.97,7.97s7.7,3.47,7.7,7.7c0-4.41,3.56-8.01,7.97-8.01s8.01,3.6,8.01,8.01c0-13.04-10.64-23.67-23.67-23.67-4.41,0-7.97,3.6-7.97,8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.49,231.56c-.2,0-.36-.16-.36-.36,0-4.22-3.43-7.65-7.65-7.65s-7.6,3.43-7.6,7.65c0,.2-.16.36-.36.36s-.36-.16-.36-.36c0-4.04-3.29-7.34-7.34-7.34-4.59,0-8.33-3.74-8.33-8.33s3.74-8.37,8.33-8.37c13.25,0,24.04,10.78,24.04,24.04,0,.2-.16.36-.36.36Zm-23.67-23.67c-4.19,0-7.6,3.43-7.6,7.65s3.41,7.61,7.6,7.61c3.6,0,6.66,2.38,7.69,5.64,1.04-3.44,4.22-5.95,7.97-5.95,3.12,0,5.84,1.71,7.28,4.25-1.95-10.89-11.5-19.19-22.95-19.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m68.83,255.22H19.95c-4.6,0-8.35-3.74-8.35-8.35s3.75-8.35,8.35-8.35h48.88c4.03,0,7.31-3.28,7.31-7.32s-3.28-7.31-7.31-7.31c-4.6,0-8.35-3.75-8.35-8.35s3.75-8.35,8.35-8.35c13.24,0,24.01,10.77,24.01,24.02s-10.77,24.02-24.01,24.02Zm-48.88-15.97c-4.2,0-7.63,3.42-7.63,7.63s3.42,7.63,7.63,7.63h48.88c12.84,0,23.29-10.45,23.29-23.29s-10.45-23.29-23.29-23.29c-4.2,0-7.63,3.42-7.63,7.63s3.42,7.63,7.63,7.63c4.43,0,8.04,3.61,8.04,8.04s-3.61,8.04-8.04,8.04H19.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.62 141.95 128.48 137.33 126.76 137.33 127.62 141.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.46 141.95 111.6 137.33 113.32 137.33 112.46 141.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m144.21,119.66c-4.51-1.72-11.83-1.72-16.34,0,.99-3.6,4.25-6.27,8.17-6.27s7.18,2.66,8.17,6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m144.21,120.02s-.09,0-.13-.02c-4.43-1.69-11.65-1.69-16.08,0-.12.05-.27.02-.37-.07-.1-.09-.14-.23-.11-.36,1.05-3.85,4.56-6.53,8.52-6.53s7.46,2.69,8.52,6.53c.04.13,0,.27-.11.36-.07.06-.15.09-.24.09Zm-8.17-6.27c-3.4,0-6.43,2.16-7.6,5.32,4.37-1.42,10.84-1.42,15.2,0-1.17-3.16-4.2-5.32-7.6-5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m112.21,119.66c-4.51-1.72-11.83-1.72-16.34,0,.99-3.6,4.25-6.27,8.17-6.27s7.18,2.66,8.17,6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m112.21,120.02s-.09,0-.13-.02c-4.43-1.69-11.64-1.69-16.08,0-.12.05-.27.02-.37-.07-.1-.09-.14-.23-.11-.36,1.05-3.85,4.56-6.53,8.52-6.53s7.46,2.69,8.52,6.53c.04.13,0,.27-.11.36-.07.06-.15.09-.24.09Zm-8.17-2.01c2.71,0,5.42.35,7.6,1.06-1.17-3.16-4.2-5.32-7.6-5.32s-6.43,2.16-7.6,5.32c2.18-.71,4.89-1.06,7.6-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m146.19,134.05c-.1-.17-.33-.22-.5-.12-7.79,4.67-17.45,4.69-25.27.1v-2.02c1.59-.56,3.12-2.08,3.53-3.61-2.15-2.08-5.64-2.08-7.79,0,.41,1.54,1.94,3.06,3.53,3.61v2c-7.83,4.61-17.51,4.6-25.31-.08-.18-.1-.4-.05-.5.12-.1.17-.05.39.12.5,4.04,2.42,8.57,3.63,13.11,3.63s8.92-1.19,12.92-3.54c4,2.35,8.46,3.54,12.92,3.54s9.06-1.21,13.11-3.63c.17-.1.23-.33.12-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m446.49,255.21H.36c-.2,0-.36-.16-.36-.36s.16-.36.36-.36h446.13c.2,0,.36.16.36.36s-.16.36-.36.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m446.16,173.53h-16.27c-.2,0-.36.16-.36.36s.16.36.36.36h16.27c15.02,0,27.23,12.22,27.23,27.23s-12.22,27.23-27.23,27.23h-31.95c-.2,0-.36.16-.36.36s.16.36.36.36h31.95c15.41,0,27.96-12.54,27.96-27.96s-12.54-27.96-27.96-27.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m410.15,234.4c-2.43,0-4.41-2.39-4.41-5.32s1.98-5.32,4.41-5.32,4.42,2.39,4.42,5.32-1.98,5.32-4.42,5.32Zm0-9.92c-2.03,0-3.69,2.06-3.69,4.6s1.65,4.6,3.69,4.6,3.69-2.06,3.69-4.6-1.65-4.6-3.69-4.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 410.15,
    cy: 229.08,
    rx: 2.21,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 197.86,
    y: 188.11,
    width: 46.32,
    height: 46.32,
    rx: 5.79,
    ry: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.52,
    y: 196.78,
    width: 28.99,
    height: 28.99,
    rx: 14.49,
    ry: 14.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m221.02,226.13c-8.19,0-14.86-6.66-14.86-14.85s6.67-14.86,14.86-14.86,14.86,6.66,14.86,14.86-6.67,14.85-14.86,14.85Zm0-28.99c-7.79,0-14.13,6.34-14.13,14.13s6.34,14.13,14.13,14.13,14.13-6.34,14.13-14.13-6.34-14.13-14.13-14.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "229.51 171.32 223.67 171.32 223.67 159.63 214.9 174.25 220.74 174.25 220.74 185.94 229.51 171.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "238.6 177.69 229.66 182.66 232.69 184.41 229.19 190.49 238.13 185.52 235.09 183.77 238.6 177.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "213.88 181.14 210.84 182.89 207.33 176.81 207.16 187.04 210.2 185.29 213.7 191.37 213.88 181.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.83,137.84c-4.29,3.27-7.51,7.93-8.94,13.44l-3.95,15.22c-.05.19.07.39.26.44.19.06.39-.07.44-.26l3.95-15.22c1.46-5.64,4.87-10.35,9.38-13.54-.38-.03-.76-.03-1.14-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m333.33,84.57c-28.71,0-53.89,20.37-59.89,48.45l-24.3,113.71c-4.4,20.59-22.87,35.53-43.93,35.53s-40.01-15.3-44.1-36.37l-18.04-93.1c-1.17-6.05-4.52-11.22-9.12-14.79-.38.01-.75.06-1.13.05,4.82,3.48,8.34,8.71,9.53,14.87l18.04,93.1c4.15,21.42,22.99,36.96,44.81,36.96s40.16-15.19,44.63-36.1l24.3-113.71c5.93-27.74,30.82-47.88,59.18-47.88.2,0,.36-.16.36-.36s-.16-.36-.36-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.32,166.3c-3.95-.75-7.76,1.84-8.52,5.79l-1.12,5.85,14.3,2.73,1.12-5.85c.75-3.95-1.84-7.76-5.79-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m97.8,180.65l-1.39-.27,1.05-5.5c.79-4.14-1.93-8.15-6.07-8.94-4.14-.78-8.15,1.93-8.94,6.08l-1.05,5.5-1.39-.27c-.2-.03-.39.09-.42.29-.04.2.09.38.29.42l5.08.97-1.33,6.98c-.04.2.09.38.29.42.02,0,.05,0,.07,0,.17,0,.32-.12.35-.29l1.33-6.98,3.11.6,3.11.6-1.33,6.98c-.04.2.09.38.29.42.02,0,.05,0,.07,0,.17,0,.32-.12.35-.29l1.33-6.98,3.33.64s0,0,0,0l1.74.33s.05,0,.07,0c.17,0,.32-.12.35-.29.04-.2-.09-.38-.29-.42Zm-14.65-8.5c.72-3.75,4.35-6.23,8.1-5.5,3.75.72,6.21,4.35,5.5,8.09l-1.05,5.5-4.86-.93-8.74-1.67,1.05-5.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 213.64,
    y: 209.53,
    width: 3.49,
    height: 3.49,
    rx: 1.75,
    ry: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.9,
    y: 209.53,
    width: 3.49,
    height: 3.49,
    rx: 1.75,
    ry: 1.75
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.79da9d9cf00f8d6fef962a552cf8f7b4.svg";
export { ForwardRef as ReactComponent };